import { type ComponentType } from 'react';
import { BigIdeaSlide } from './components/slides/BigIdeaSlide';
import { ProblemSlide } from './components/slides/ProblemSlide';
import { PromiseSlide } from './components/slides/PromiseSlide';
import { FormatSlide } from './components/slides/FormatSlide';
import { ProofSlide } from './components/slides/ProofSlide';
import { AmbitionSlide } from './components/slides/AmbitionSlide';
export type DeckSlide = {
  // Stable id — keep it matching this slide's screen id in canvas.manifest.js.
  id: string;
  // On-slide title — should match the Screen name in canvas.manifest.js.
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_8hhe5u',
  title: 'Time with Solventum pays back',
  component: BigIdeaSlide
}, {
  id: 'scr_prb002',
  title: 'HCP attention is expensive',
  component: ProblemSlide
}, {
  id: 'scr_prm003',
  title: 'Give us a little time',
  component: PromiseSlide
}, {
  id: 'scr_fmt004',
  title: 'The countdown becomes the signal',
  component: FormatSlide
}, {
  id: 'scr_prf005',
  title: 'Already in use',
  component: ProofSlide
}, {
  id: 'scr_amb006',
  title: 'From campaign recognition to brand trust',
  component: AmbitionSlide
}];